module.exports = __webpack_public_path__ + "img/Feature.9b7f0d23.png";